<template>
  <v-expansion-panels
    v-model="panel"
    multiple
  >
    <v-expansion-panel
    >
      <v-expansion-panel-header>
        <span
            :style="{
              'color': `${config.customTextColorContent ? config.customTextColorContent : config.ColorContent} !important`, 
              'font-size': `${config.FontSizeContent}px !important`,
              'font-family': config.FontContent
            }"
        >
          {{ question }}
        </span>
      </v-expansion-panel-header>
      <v-expansion-panel-content>
        <div
          class="result-html"
          :style="{ padding: isDesktop ? '15px 30px !important' : '12px 15px !important' }"
        >
          <v-flex
            v-html="answer" 
            class="ql-editor ql-blank"
            xs12
            :style="{
              'color': `${config.customTextColorContent ? config.customTextColorContent : config.ColorContent} !important`, 
              'font-size': `${config.FontSizeContent}px !important`,
              'font-family': config.FontContent
            }"
          />
        </div>
      </v-expansion-panel-content>
    </v-expansion-panel>
  </v-expansion-panels>
</template>
<script>

import utils from '@/services/utils'
export default {
  name:'Item16Text',
  props: {
    config: {
      type: Object,
      default: null,
    },
    content: {
      type: Object,
      default: null,
    },
    locale: {
      type: String,
      default: null,
    },
    isDesktop: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    question () {
      console.log(this.config)
      return this.content.QAndAQuestion ? utils.getTranslation (this.content.QAndAQuestion, this.locale) : ''
    },
    answer () {
      return this.content.QAndAAnswer ? utils.getTranslation (this.content.QAndAAnswer, this.locale) : ''
    },
  },
}
</script>
<style>
  .ql-editor p {
    padding: 0 !important;
  }
  .result-html .ql-toolbar.ql-snow {
    height: 0px !important;
    padding: 0px !important;
    border: 0px !important;
  }
  .result-html .ql-container.ql-snow {
    border: 0px !important;
  }
  .result-html .ql-editor {
    min-height: 0px !important;
  }   
</style>

